module.exports = __webpack_public_path__ + "static/assets/28c7b28f9d0f388898d6d6d54cc03cd3.jpg";